import * as React from 'react';
import { useEffect, useMemo, useState } from 'react';
import { Box, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import useRootHook from '../../hooks/useRoot';
import stats from '../../models/stats';
import helpers from '../../helpers/common';

const getLabel = (row, entity) => {
  if (entity === 'topMerchants') return row['merchant.name'] || row.merchant_id;
  if (entity === 'topProjects') return row['project.name'] || row.project_id;
  if (entity === 'topCustomers') return row['customer.email'] || row.customer_id;
  return row.id || '—';
};

export default function TopEntitiesCard({ title, type, filters, limit = 8 }) {
  const { defaultCurrency } = useRootHook();
  const [data, setData] = useState(null);

  useEffect(() => {
    stats.getStats({ ...filters, type, limit }).then((d) => setData(d || null));
  }, [filters, type, limit]);

  const rows = useMemo(() => {
    return Array.isArray(data?.items) ? data.items : [];
  }, [data]);

  const isTopMerchants = type === 'topMerchants';

  return (
    <Stack spacing={1.25}>
      <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
        {title}
      </Typography>
      {rows.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No data
        </Typography>
      ) : (
        <Box sx={{ overflowX: 'auto' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell align="right">Count</TableCell>
                <TableCell align="right">Amount</TableCell>
                {isTopMerchants && (
                  <>
                    <TableCell align="right">Dispute Rate</TableCell>
                    <TableCell align="right">Refund Rate</TableCell>
                  </>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((r, idx) => {
                const amount = typeof r.amount === 'string' ? parseFloat(r.amount) : (r.amount || 0);
                const amountStr = defaultCurrency
                  ? helpers.getSubunitAmountString(amount, defaultCurrency.symbol, defaultCurrency.subunit)
                  : String(amount);
                const disputeRate = r.dispute_rate ? `${parseFloat(r.dispute_rate).toFixed(2)}%` : '0.00%';
                const refundRate = r.refund_rate ? `${parseFloat(r.refund_rate).toFixed(2)}%` : '0.00%';
                return (
                  <TableRow key={`top-${idx}`}>
                    <TableCell sx={{ fontWeight: 600 }}>{getLabel(r, type)}</TableCell>
                    <TableCell align="right">{r.count}</TableCell>
                    <TableCell align="right">{amountStr}</TableCell>
                    {isTopMerchants && (
                      <>
                        <TableCell align="right">{disputeRate}</TableCell>
                        <TableCell align="right">{refundRate}</TableCell>
                      </>
                    )}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </Box>
      )}
    </Stack>
  );
}





